/**
 * CARIButton — side tab anchored to the right edge that opens the CARI
 * specialist agent panel. Same slot + style TERRA uses on other products;
 * Phreatic hides TERRA and shows this instead so users see one assistant.
 */
import { useCARIStore } from '@/store/cari';
import { SideTab } from '@/components/SideTab';

export function CARIButton() {
  const isOpen = useCARIStore((s) => s.isOpen);
  const open = useCARIStore((s) => s.open);

  return (
    <SideTab
      label="CARI"
      title="Open CARI (Comprehensive Aquifer Reasoning Intelligence)"
      accent="cyan"
      bottom={24}
      hidden={isOpen}
      onClick={open}
    />
  );
}

export default CARIButton;
